import * as React from "react";
import { Slot } from "@radix-ui/react-slot";
import cn from "clsx";

export type VERTICAL_SPACER_SIZES =
  | "xs"
  | "s"
  | "m"
  | "l"
  | "xl"
  | "2xl"
  | "3xl"
  | "4xl" 
  | "5xl";

export type VerticalSpacerProps = {
  asChild?: boolean;
  size?: VERTICAL_SPACER_SIZES;
  sizeSmall?: VERTICAL_SPACER_SIZES;
  sizeMedium?: VERTICAL_SPACER_SIZES;
  sizeLarge?: VERTICAL_SPACER_SIZES;
} & React.ButtonHTMLAttributes<HTMLDivElement>;

const VerticalSpacer = React.forwardRef<HTMLDivElement, VerticalSpacerProps>(
  (
    {
      className,
      asChild = false,
      size = "2xl",
      sizeSmall,
      sizeMedium,
      sizeLarge,
      ...props
    },
    ref
  ) => {
    const Comp = asChild ? Slot : "div";
    return (
      <Comp
        ref={ref}
        className={cn(
          `in-vertical-spacer--${sizeSmall || size}`,
          sizeMedium && `in-vertical-spacer-medium--${sizeMedium}`,
          sizeLarge && `in-vertical-spacer-large--${sizeLarge}`,
          className
        )}
        {...props}
      />
    );
  }
);

export default VerticalSpacer;
export { VerticalSpacer };
